export default __webpack_public_path__ + "static/alex-5f181cd7875fa2d1f796b3d79129dc3a.png";